import { defineMessages } from 'react-intl';

export const scope = 'axionimprovements.features.departments';

export default defineMessages({

    // no: {
    //     id: `${scope}.labels.no`,
    //     defaultMessage: 'No',
    // },
    // yes: {
    //     id: `${scope}.labels.yes`,
    //     defaultMessage: 'Yes',
    // },

    add_department: {
        id: `${scope}.labels.add_department`,
        defaultMessage: 'Add department.',
    },
    update_department: {
        id: `${scope}.labels.add_department`,
        defaultMessage: 'Update department.',
    },
    delete_department: {
        id: `${scope}.labels.delete_department`,
        defaultMessage: 'Delete department.',
    },
    add_a_new_department: {
        id: `${scope}.labels.add_a_new_department`,
        defaultMessage: 'Add a new department.',
    },
    update_a_department: {
        id: `${scope}.labels.update_a_department`,
        defaultMessage: 'Update a department.',
    },
    could_not_update_department: {
        id: `${scope}.labels.could_not_update_department`,
        defaultMessage: 'Could not update the Department.',
    },
    could_not_create_department: {
        id: `${scope}.labels.could_not_create_department`,
        defaultMessage: 'Could not create the Department.',
    },
    edit_department: {
        id: `${scope}.labels.edit_department`,
        defaultMessage: 'Edit the department.',
    },
    departments: {
        id: `${scope}.labels.departments`,
        defaultMessage: 'Departments.',
    },
    delete: {
        id: `${scope}.labels.delete`,
        defaultMessage: 'Delete.',
    },
    yes: {
        id: `${scope}.labels.yes`,
        defaultMessage: 'Yes.',
    },
    no: {
        id: `${scope}.labels.no`,
        defaultMessage: 'No.',
    },
    could_not_delete_department: {
        id: `${scope}.labels.could_not_delete_department`,
        defaultMessage: 'Could not delete the department.',
    },
    sure_delete_department: {
        id: `${scope}.labels.sure_delete_department`,
        defaultMessage: 'Are you sure you want to delete the department.',
    },


});